import {
  Box,
  Button,
  Container,
  ListItem,
  ListItemButton,
  Stack,
  SxProps,
  useTheme,
} from '@mui/material';

import { FC } from 'react';
import { ILocale } from '@/lang/types';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { WalletSidMenuAuthHint } from './wallet-side-menu-auth-hint';
import { checkIsRtl } from '@/lang/utils';
import { useRouter } from 'next/router';
import { pxToRem } from '@/theme/typography';

interface WalletCashbackCompleteProfileBadgeProps {
  message: string;
  handleClick: () => void;
}

const WalletCashbackCompleteProfileBadge: FC<WalletCashbackCompleteProfileBadgeProps> = ({
  message,
  handleClick,
}) => {
  const theme = useTheme();
  const router = useRouter();

  const isRtl = checkIsRtl(router.locale as ILocale);

  const ArrowIConSx: SxProps = {
    transition: '0.3s ease-out',
    color: theme.palette.grey[80],
    '&:hover': {
      transition: '0.3s ease-out',
      WebkitTransform: 'translateX(4px)',
      MozTransform: 'translateX(4px)',
      msTransform: 'translateX(4px)',
      OTransform: 'translateX(4px)',
      transform: 'translateX(4px)',
      WebkitTransition: 'transform 0.3s ease-out',
      MozTransition: 'transform 0.3s ease-out',
      msTransition: 'transform 0.3s ease-out',
      OTransition: 'transform 0.3s ease-out',
      color: 'white',
    },
  };

  return (
    <Container
      component='section'
      sx={{
        width: '100%',
        p: 0,
        marginBlockStart: 4,
      }}
    >
      <ListItem
        key='wallet-cashback-badge'
        component='div'
        disableGutters
        sx={{
          paddingBlock: '10.5px',
          display: {
            mobile: 'flex',
            mediumDesktop: 'flex',
          },
        }}
      >
        <ListItemButton
          component='a'
          disableGutters
          sx={{
            height: pxToRem(66),
            borderRadius: '12px',
            paddingX: '16px',
            paddingY: '8px',
            backgroundColor: theme.palette.primary.light,
            '&:hover': {
              backgroundColor: '#f2c3fb',
            },
          }}
          onClick={handleClick}
        >
          <Stack
            direction='row'
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center',
              flexGrow: 1,
            }}
          >
            <WalletSidMenuAuthHint
              message={message}
              img='/icons/profile/wallet-cashback-profile-icon.svg'
              textColor={theme.palette.primary.main}
            />

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Button
                variant='contained'
                sx={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '100%',
                  minWidth: 'unset',
                  minHeight: 'unset',
                  backgroundColor: 'white',
                }}
              >
                {isRtl ? (
                  <KeyboardArrowLeftIcon sx={ArrowIConSx} />
                ) : (
                  <KeyboardArrowRightIcon sx={ArrowIConSx} />
                )}
              </Button>
            </Box>
          </Stack>
        </ListItemButton>
      </ListItem>
    </Container>
  );
};

export default WalletCashbackCompleteProfileBadge;
